import React from "react"
import BaseGantt from "./shared/BaseGantt"

const CustomGanttChair = props => {
	return (
		<BaseGantt
			viewType="chair"
			resourceId={props.chairId}
			resourceName={props.chairName}
			{...props}
		/>
	)
}

export default React.memo(CustomGanttChair)
